import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { Entity } from '../types/entity';
import queryClient from '../query-client';

type RefreshXeroEntityRequest = {
    entityId: string;
    refreshShortCodeOnly?: boolean;
};

async function refreshXeroEntity({ entityId, refreshShortCodeOnly }: RefreshXeroEntityRequest): Promise<{ entity: Entity }> {
    const { data } = await api.post(`/entities/${entityId}/integrations/xero/refresh${refreshShortCodeOnly ? '?shortCode=true' : ''}`);
    return data;
}

export function useRefreshXeroEntity(
    entityId?: string
): UseMutationResult<{ entity: Entity }, AxiosError, RefreshXeroEntityRequest, unknown> {
    return useMutation(refreshXeroEntity, {
        onSettled: () => {
            queryClient.invalidateQueries(['entities', entityId]);
        },
    });
}
